import logoPic from '../../assets/logo.png';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export default function Logo() {
  return (
    <Link to="/" style={{display: 'flex', alignItems: 'center'}}>
      <img alt="لوگوی هفسین " className="desktop_navbar__logo" src={logoPic}  />
      <Typography variant="h5" component="p" style={{ fontWeight: 800, color: '#000' }}>
        هفسین
      </Typography>
    </Link>
  );
}
